// IMPORTANT: Keep in sync with functions/src/index.ts
const STRIPE_PRICE_ID_PREFIX = 'price_';
/**
 * Normalizes customer-entered promotion values while preserving raw Stripe
 * price ids that power sale-negotiation offers.
 */
const normalizePromotionCodeForValidation = (promotionCode: string): string => {
    const trimmedPromotionCode = `${promotionCode || ''}`.trim();
    if (!trimmedPromotionCode) return '';
    if (trimmedPromotionCode.toLowerCase().startsWith(STRIPE_PRICE_ID_PREFIX)) {
        return trimmedPromotionCode;
    }
    return trimmedPromotionCode.toUpperCase();
};

export default normalizePromotionCodeForValidation;
